/**
 * Mobile Bottom Toolbar
 * Shows on mobile devices (<768px) to replace desktop panels
 */

import { memo } from 'react'
import { Library, Settings, Download, MoreHorizontal } from 'lucide-react'
import '../../styles/mobile-toolbar.css'

interface MobileToolbarProps {
  onOpenLibrary?: () => void
  onOpenProperties?: () => void
  onExport?: () => void
  onShowMore?: () => void
}

const ICON_SIZE = 22

function MobileToolbar({
  onOpenLibrary,
  onOpenProperties,
  onExport,
  onShowMore,
}: MobileToolbarProps) {
  return (
    <div className="mobile-toolbar">
      <button
        onClick={onOpenLibrary}
        className="mobile-toolbar-btn"
        title="Node Library"
        aria-label="Node Library"
      >
        <Library size={ICON_SIZE} className="mobile-toolbar-icon" aria-hidden />
        <span className="mobile-toolbar-label">Library</span>
      </button>

      <button
        onClick={onOpenProperties}
        className="mobile-toolbar-btn"
        title="Properties"
        aria-label="Properties"
      >
        <Settings size={ICON_SIZE} className="mobile-toolbar-icon" aria-hidden />
        <span className="mobile-toolbar-label">Props</span>
      </button>

      <button
        onClick={onExport}
        className="mobile-toolbar-btn"
        title="Export"
        aria-label="Export"
      >
        <Download size={ICON_SIZE} className="mobile-toolbar-icon" aria-hidden />
        <span className="mobile-toolbar-label">Export</span>
      </button>

      <button
        onClick={onShowMore}
        className="mobile-toolbar-btn"
        title="More Options"
        aria-label="More Options"
      >
        <MoreHorizontal
          size={ICON_SIZE}
          className="mobile-toolbar-icon"
          aria-hidden
        />
        <span className="mobile-toolbar-label">More</span>
      </button>
    </div>
  )
}

export default memo(MobileToolbar)
